// src/features/audit-monitor/hooks/useAuditData.js
import { useState, useEffect } from 'react';
import { get, map, size, groupBy } from 'lodash';
import { useApollo } from '../../../components/contexts/ApolloContext';
import { QUERY_GET_PICKING_FEED } from '../../../components/graphql/getAuditOrders';
import { AuditDataService } from '../services/auditDataService';

export const useAuditData = (queryFilters) => {
    const client = useApollo();
    const [processedData, setProcessedData] = useState({
        groupedData: {},
        totalCount: 0,
        hasData: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = async (manualRefetch = false) => {
        if (!queryFilters) return;
        try {
            !manualRefetch && setLoading(true);
            setError(null);
            
            const response = await client.query({
                query: QUERY_GET_PICKING_FEED,
                variables: queryFilters,
                fetchPolicy: 'network-only'
            });

            const results = get(response, 'data.getAuditOrder.results', []);

            // Transformar la estructura de datos para que coincida con lo esperado
            const rawOrders = map(results, ({ orderWithLoader, pickerWithLoader, ...assignInfo }) => {
                const transformedOrder = {
                    ...orderWithLoader,
                    assignInfo: { 
                        picker: pickerWithLoader, 
                        ...assignInfo,
                        bipicking: false, //deshabilita bipicking 
                        ordersBipicking: null, //deshabilita bipicking 
                        // Asegurar que auditInfo esté presente
                        auditInfo: {
                            ...get(assignInfo, 'auditInfo', {}),
                            rules: get(assignInfo, 'auditInfo.rules', ['quantity', 'price']), // Default rules si no vienen
                            passedCount: get(assignInfo, 'auditInfo.passedCount', 0),
                            failedCount: get(assignInfo, 'auditInfo.failedCount', 0)
                        }
                    }
                };
                
                return transformedOrder;
            });
            
            // Usar el nuevo método que maneja bipicking
            const processed = AuditDataService.processDataWithBipicking(rawOrders);
            setProcessedData({
                ...processed,
                count: get(response, 'data.pickingFeed.count', 0),
                totals: size(results) ? groupBy(results, 'status.code') : {}
            });
            
        } catch (err) {
            console.error('Error fetching audit data:', err);
            setError(err);
            setProcessedData({
                groupedData: {},
                totalCount: 0,
                hasData: false
            });
        } finally {
            !manualRefetch && setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(false);
    }, [queryFilters]);

    useEffect(() => {
        if (!queryFilters) return;
        
        const interval = setInterval(() => {
            fetchData();
        }, 60000);

        return () => clearInterval(interval);
    }, [queryFilters]);

    const manualRefetch = async () => {
        await fetchData(true);
    };

    return {
        ...processedData,
        loading,
        error,
        refetch: manualRefetch,
        rawData: processedData.rawData || []
    };
};